// extracted by mini-css-extract-plugin
module.exports = {"overlayItems":"OverlayItems_overlayItems_38xnp"};